import React from 'react';
import LocationTemplate from './LocationTemplate';

const PrincetonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Princeton"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27569"]}
      latitude={35.4668}
      longitude={-78.1606}
      population={1309}
      historicalFact="Originally called Boon Hill, renamed Princeton in 1873 after Princeton, New Jersey."
      nearbyTowns={[
        "Selma, NC",
        "Four Oaks, NC",
        "Kenly, NC",
        "Pine Level, NC",
        "Micro, NC",
        "Smithfield, NC",
        "Goldsboro, NC",
        "Wilson, NC"
      ]}
    />
  );
};

export default PrincetonPage;